import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getCompareMode,
  getCurrentSummaryData,
  getSummaryDimensions,
  getTableLoading,
  getSummaryKpiSelected
} from "../../../selectors";
import { fetchStats } from "../../../actions/stats";
import { Button, Col, Divider, Dropdown, Menu, Icon } from "antd";
import Dimension from "./Dimension";
import Spinner from "../../../components/Spinner";
import DimensionsTitle from "./DimensionsTitle";
import { TYPE_SORT } from "../Global/constants";
import { getDimensionTitle, getDimensionLabel } from "../../../summary/dimensions";
import _ from "lodash";
import html2canvas from "html2canvas";
import moment from "moment";
import FileSaver from "file-saver";
const TITLE_HEIGHT = 50;
const countDistinctValuesOfLevel = (dataset = {}, level = 0, currentLevel = 0, values = []) => {
  //if(currentLevel>level) return;

  const data = dataset.data || [];

  if (level === currentLevel) {
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];
      const dimValue = datum.dim_value;
      const dimInfos = datum.dim_infos || {};
      const key = dimValue + JSON.stringify(dimInfos);
      if (dimValue && values.indexOf(key) === -1) {
        values.push(key);
      }
    }
  }
  currentLevel++;
  for (let i = 0; i < data.length; i++) {
    const dataElt = data[i];
    countDistinctValuesOfLevel(dataElt, level, currentLevel, values);
  }

  return values.length;
};
export const getDimensions = (
  dataset,
  dimensions,
  level = 0,
  isComparing = false,
  progressBarDelay = false,
  currentLevel = 0,
  currentDimensions = [],
  ref = 0,
  fullWidth = false
) => {
  let indexGraph = dataset.indexGraph ? dataset.indexGraph : 0;
  if (currentLevel > level) return [];
  if (level === currentLevel) {
    let dimensionData = { labels: [], value: {} };
    let nbTotal = 0;
    for (let i = 0; i < dimensions.length; i++) {
      if (currentDimensions[i]) {
        dimensionData.labels.push(currentDimensions[i]);
      } else {
        dimensionData.labels.push(`Total (${countDistinctValuesOfLevel(dataset, nbTotal, 0)})`);
        nbTotal++;
      }
    }
    let value = dataset.value;
    const p1 = { ...dataset.p1 } || {};
    if (!dataset.format || dataset.format === "/" || dataset.format === "weight") {
      if (dataset.value !== null) {
        value = (100 * dataset.value) / ref || 0;
      }

      if (p1.value !== null) {
        //p1.value = p1.value || 0;
        p1.value = (100 * p1.value) / ref || 0;
      }
    }

    dimensionData.value = {
      v: dataset.v,
      n: dataset.n,
      value: value,
      valueStr: dataset.valueStr,
      format: dataset.format,
      unit: dataset.unit,
      p1: p1,
      diff: dataset.diff
    };

    return [
      <Dimension
        {...dimensionData}
        fullWidth={fullWidth}
        progressBarDelay={progressBarDelay}
        isComparing={isComparing}
        indexGraph={indexGraph}
      />
    ];
  }

  const data = dataset.data;
  if (data && data.length > 0) {
    const dims = [];
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];
      // const dimensionLabel = datum.dim_value || "";
      const dimensionLabel = getDimensionLabel(datum);
      datum.indexGraph = indexGraph;
      let nextRef = dataset.value;
      if (!dataset.format || dataset.format === "/" || dataset.format === "weight") {
        const data = Array.isArray(dataset.data) ? dataset.data : [];
        nextRef = Math.max.apply(
          Math,
          data.map(item => item.value)
        );
      }
      const dimData = getDimensions(
        datum,
        dimensions,
        level,
        isComparing,
        progressBarDelay,
        currentLevel + 1,
        [...currentDimensions, dimensionLabel],
        nextRef,
        fullWidth
      );
      if (dimData) {
        for (let j = 0; j < dimData.length; j++) {
          const dimDatum = dimData[j];
          indexGraph++;
          dims.push(dimDatum);
        }
      }
    }

    if (dims.length > 0 && currentLevel > 0 && currentLevel === level - 1) {
      //add sub total
      let dimensionData = { labels: [], value: {} };
      let nbTotal = 0;
      for (let i = 0; i < dimensions.length; i++) {
        if (currentDimensions[i]) {
          dimensionData.labels.push(currentDimensions[i]);
        } else {
          dimensionData.labels.push(`Total (${countDistinctValuesOfLevel(dataset, nbTotal, 0)})`);
          nbTotal++;
          //dimensionData.labels.push("Total");
        }
      }

      //set percent to 100% (value as reference)
      let value = dataset.value;
      if (!dataset.format) value = 100;

      dimensionData.value = {
        v: dataset.v,
        n: dataset.n,
        value: value,
        valueStr: dataset.valueStr,
        format: dataset.format,
        unit: dataset.unit,
        p1: dataset.p1,
        diff: dataset.diff
      };

      dims.unshift(
        <Dimension
          key={Math.random() + ""}
          {...dimensionData}
          fullWidth={fullWidth}
          isComparing={isComparing}
          indexGraph={indexGraph}
          progressBarDelay={progressBarDelay}
        />
      );
      dims.unshift(<Divider key={Math.random() + ""} />);
    }

    return dims;
  }
  return [];
};
const sortData = (data = {}, sortTypeByDimension, dimension = 0) => {
  if (dimension >= sortTypeByDimension.length || !Array.isArray(data.data)) return data;

  const dataDim = _.cloneDeep(data.data);
  dataDim.sort((a, b) => {
    if (sortTypeByDimension[dimension] === TYPE_SORT.ALPHABETICALLY) {
      if (a.dim_value > b.dim_value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.INCREASING) {
      if (a.value > b.value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.DECREASING) {
      if (a.value < b.value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.DECREASING_P2) {
      if (a.p1.value < b.p1.value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.INCREASING_P2) {
      if (a.p1.value > b.p1.value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.DECREASING_GAIN) {
      if (a.diff.value < b.diff.value) return 1;
      else return -1;
    } else if (sortTypeByDimension[dimension] === TYPE_SORT.INCREASING_GAIN) {
      if (a.diff.value > b.diff.value) return 1;
      else return -1;
    }
  });

  for (let i = 0; i < dataDim.length; i++) {
    data.data[i] = sortData(dataDim[i], sortTypeByDimension, dimension + 1);
  }

  return data;
};
const Dimensions = props => {
  const dimensions = props.dimensions || [];
  const data = props.data || {};
  const isComparing = props.isComparing || false;
  const kpi = props.kpi || {};
  const period = props.period || [];
  const periodToCompare = props.periodToCompare || [];
  const [sortTypeByDimension, setSortTypeByDimension] = useState(
    Array(dimensions.length).fill(TYPE_SORT.ALPHABETICALLY)
  );

  const [dataSorted, setDataSorted] = useState(sortData(data, sortTypeByDimension, 0));
  useEffect(() => {
    setDataSorted(sortData(data, sortTypeByDimension, 0));
  }, [data, sortTypeByDimension]);

  let dimensionData = { labels: [], value: {} };
  for (let i = 0; i < dimensions.length; i++) {
    dimensionData.labels.push("Total");
  }
  let value = data.value;
  if (!data.format) value = 100;
  dimensionData.value = { v: data.v, n: data.n, value: value, valueStr: data.valueStr };
  let progressBarDelay = true;

  if (dimensions.length > 1) progressBarDelay = false;
  else if (Array.isArray(dataSorted.data) && dataSorted.length > 50) progressBarDelay = false;

  const menuSortItems = [
    { key: TYPE_SORT.INCREASING, label: "Trier par ordre croissant", alwaysDisplay: true },
    { key: TYPE_SORT.DECREASING, label: "Trier par ordre décroissant", alwaysDisplay: true },
    { key: TYPE_SORT.ALPHABETICALLY, label: "Trier par ordre alphabétique", alwaysDisplay: false },
    { key: TYPE_SORT.INCREASING_P2, label: "Trier par ordre croissant (période 2)", alwaysDisplay: false },
    { key: TYPE_SORT.DECREASING_P2, label: "Trier par ordre décroissant (période 2)", alwaysDisplay: false },
    { key: TYPE_SORT.INCREASING_GAIN, label: "Trier gain croissant", alwaysDisplay: false },
    { key: TYPE_SORT.DECREASING_GAIN, label: "Trier gain décroissant", alwaysDisplay: false }
  ];
  const sortMenu = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ display: "flex" }}>
        {dimensions.map((dimensionLabel, index) => (
          <Dropdown
            overlay={
              <Menu
                style={{ width: 400 }}
                onClick={({ key }) => {
                  const newSortType = [...sortTypeByDimension];
                  newSortType[index] = key;
                  setSortTypeByDimension(newSortType);
                }}
              >
                {menuSortItems
                  .filter(item => item.alwaysDisplay || isComparing)
                  .map(item => (
                    <Menu.Item key={item.key}>{item.label}</Menu.Item>
                  ))}
              </Menu>
            }
          >
            <Button style={{ display: "flex", marginTop: 10, marginBottom: 10, marginRight: 5 }}>
              <div style={{ marginRight: 20 }}>
                {getDimensionTitle(dimensionLabel)} : {sortTypeByDimension[index]}
              </div>
            </Button>
          </Dropdown>
        ))}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          onClick={() => {
            for (let i = 1; i <= dimensions.length + 1; i++) {
              html2canvas(document.getElementById(`dim${i}`), {
                height: document.getElementById(`dim${i}`).offsetHeight,
                width: document.getElementById(`dim${i}`).offsetWidth,
                onclone: document => {
                  document.getElementById(`dim${i}`).style.margin = 0;
                  document.getElementById(`dim${i}`).style.padding = 0;
                }
              }).then(function(canvasToCopy) {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = canvasToCopy.width;
                canvas.height = canvasToCopy.height + TITLE_HEIGHT * 1.5;
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = "#000000";
                ctx.font = "bold 13px Arial";
                ctx.textAlign = "center";
                let dimensionTitle = "";
                if (i === 1) {
                  dimensionTitle = `total`;
                } else {
                  dimensionTitle = `dim ${i - 1}-${getDimensionTitle(dimensions[i - 2])}`;
                }
                let titleGraph = ` ${kpi.long_label} / ${dimensionTitle} du ${moment(period[0]).format(
                  "DD.MM.YYYY"
                )} au ${moment(period[1]).format("DD.MM.YYYY")}`;
                if (isComparing) {
                  titleGraph = `Gain ${kpi.long_label} / ${dimensionTitle} du ${moment(period[0]).format(
                    "DD.MM.YYYY"
                  )} au ${moment(period[1]).format("DD.MM.YYYY")} ET ${moment(periodToCompare[0]).format(
                    "DD.MM.YYYY"
                  )} au ${moment(periodToCompare[1]).format("DD.MM.YYYY")}`;
                }
                ctx.fillText(titleGraph, canvas.width / 2, TITLE_HEIGHT / 2);
                ctx.drawImage(canvasToCopy, 0, TITLE_HEIGHT);

                FileSaver.saveAs(canvas.toDataURL(), `${titleGraph}.png`);
              });
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <Icon type="camera" />
        </Button>
      </div>
    </div>
  );
  const sortIcons = dimensions.length <= 4 && !props.loading ? sortMenu : null;
  const hasData = data.value !== null || (data.p1 && data.p1.value !== null);
  return (
    <Fragment>
      <Col>
        {props.loading && <Spinner />}
        {!props.loading && !hasData && (
          <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            Aucune donnée sur cette période
          </div>
        )}
        {!props.loading &&
          hasData && [
            sortIcons,
            <DimensionsTitle
              dimensions={props.dimensions}
              period={props.period}
              periodToCompare={props.periodToCompare}
              isComparing={isComparing}
            />,
            <div id="top-stats" style={{ height: 10 }}></div>,
            <div id="dim1">{getDimensions(dataSorted, dimensions, 0, isComparing, progressBarDelay)}</div>,
            <div id="dim2">{getDimensions(dataSorted, dimensions, 1, isComparing, progressBarDelay)}</div>,

            <div id="dim3">{getDimensions(dataSorted, dimensions, 2, isComparing, progressBarDelay)}</div>,

            <div id="dim4">{getDimensions(dataSorted, dimensions, 3, isComparing, progressBarDelay)}</div>,
            <div id="dim5">{getDimensions(dataSorted, dimensions, 4, isComparing, progressBarDelay)}</div>
          ]}
        <div id="bottom-stats"></div>
      </Col>
    </Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    data: getCurrentSummaryData(state),
    dimensions: getSummaryDimensions(state),
    loading: getTableLoading(state),
    period: state.stats.period,
    periodToCompare: state.stats.periodToCompare,
    isComparing: getCompareMode(state),
    kpi: getSummaryKpiSelected(state)
  };
};

export default connect(mapStateToProps, { fetchStats })(Dimensions);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Dimension/Dimensions.js